import React, {useEffect} from "react";
import logo from "../../assets/logo-header.png";
import Button from "../../components/v2/Button";
import {Link} from "react-router-dom";
import useValetStore from "./hooks/useValetStore";
import Caroussel from "../../components/v2/Caroussel";


import ServiceHeader from "../../assets/v2/service_header.png";
import ServiceIcon from "../../assets/v2/service_icon_valet.png";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useTranslation} from "react-i18next";

import Image1 from "../../assets/v2/caroussel/1.png";
import Image2 from "../../assets/v2/caroussel/2.png";
import Image3 from "../../assets/v2/caroussel/3.png";

import Image1_en from "../../assets/v2/caroussel/1_en.png";
import Image2_en from "../../assets/v2/caroussel/2_en.png";
import Image3_en from "../../assets/v2/caroussel/3_en.png";
import {twMerge} from "tailwind-merge";
import {Languages} from "../../constants/Languages";

export default function ValetSplash(
    {
        orderClickedHandler
    }
) {

    const {
        accessToken
    } = useValetStore();

    const {height, width} = useWindowDimensions();
    const {t, i18n} = useTranslation('common');

    return <div className="h-full flex flex-col p-4">
        <img src={logo} className="mt-4 mx-auto max-w-xs"/>
        <div className="flex items-center justify-between gap-0 my-4">
            <div>
                <img src={ServiceHeader} className=""/>
            </div>
            <div className="h-full flex-grow flex">
                <div className="flex-grow bg-white bg-opacity-20 flex flex-col justify-center">
                    <div className={twMerge("flex flex-col", i18n.language === Languages.EN ? "flex-col-reverse" : "")}>
                        <div className="mb-[-2px] tracking-[2px]">{t('valet.splash.text')}</div>
                        <div className="mt-[-2px] text-xl tracking-[2px]"><b>{t('valet.splash.text2')}</b></div>
                    </div>
                </div>
                <div className="relative overflow-visible w-10">
                    <img src={ServiceIcon} className="absolute top-[-58px] left-[-90px] min-w-[146px] min-h-[146px]"/>
                </div>
            </div>
        </div>

        <Caroussel
            diapos={
                i18n.language === 'en' ?
                    [
                        {image: Image1_en},
                        {image: Image2_en},
                        {image: Image3_en}
                    ] : [
                        {image: Image1},
                        {image: Image2},
                        {image: Image3}
                    ]
            }
            aside={width >= 1200}
        />
        <div className="grow"></div>
        <div className="flex flex-col gap-4">
            <Button text={t('valet.splash.order')} clickHandler={orderClickedHandler}/>
            {accessToken == null ?
                <Link to="/login"> <Button outline text={t('valet.splash.already_customer')}/></Link>
                : null
            }
        </div>

    </div>
}